import React from 'react';

const conditionTypes = [
  {value: '=', label: '='},
  {value: 'hasValue', label: 'has a value'},
];

class ConditionType extends React.Component {

  constructor(props) {
    super(props);

    const leftFieldType = props.leftFieldType;
    const allowedConditionTypes = conditionTypes.filter(ct => this.isValueAllowed(ct.value, leftFieldType));

    let value = props.value;
    if (!value || !allowedConditionTypes.map(ct => ct.value).includes(value)) {
      value = allowedConditionTypes[0].value;
      props.onChange(value);
    }
    this.state = {
      value: value,
      allowedConditionTypes: allowedConditionTypes,
    };
  }

  isValueAllowed(conditionType, leftFieldType) {
    if (!conditionType) {
      return false;
    } else if (!leftFieldType) {
      return true;
    } else {
      switch(conditionType) {
      case 'hasValue':
        return leftFieldType !== 'CHECKBOX' && leftFieldType !== 'RADIO';
      default:
        return leftFieldType === 'CHECKBOX' || leftFieldType === 'RADIO' || leftFieldType === 'DROPDOWN';
      }
    }
  }

  updateValue(value) {
    this.setState({value: value}, () => this.props.onChange(this.state.value));
  }

  render() {
    return <select className="form-select"
                   value={this.state.value || ''}
                   onChange={e => this.updateValue(e.target.value)}>
      {this.state.allowedConditionTypes.map(ct =>
        <option key={ct.value} value={ct.value}>{ct.label}</option>
      )}
    </select>;
  }

}
export default ConditionType;